import {
  GETWALLETOWNERBANKDETAILSLIST_SUCCESS,
  GETWALLETOWNERBANKDETAILSLIST_FAILED,
  RESET_GETWALLETOWNERBANKDETAILSLIST,
  LOADING_GETWALLETOWNERBANKDETAILSLIST,
  NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetWalletOwnerBankDetailsList = () => {
  return { type: RESET_GETWALLETOWNERBANKDETAILSLIST };
};

const getWalletOwnerBankDetailsListReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWALLETOWNERBANKDETAILSLIST });
    await partnerServices
      .post("getWalletOwnerBankDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getWalletOwnerBankDetailssuccess(res.data));
            break;
          default:
            dispatch(getWalletOwnerBankDetailsFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST,
          payload: err,
        });
      });
  };
function getWalletOwnerBankDetailssuccess(data) {
  return {
    type: GETWALLETOWNERBANKDETAILSLIST_SUCCESS,
    payload: data,
  };
}
function getWalletOwnerBankDetailsFailed(data) {
  return {
    type: GETWALLETOWNERBANKDETAILSLIST_FAILED,
    payload: data,
  };
}

export { resetGetWalletOwnerBankDetailsList, getWalletOwnerBankDetailsListReq };
